import {
  Box,
  Button,
  Dialog,
  DialogContent,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { CheckCircleIcon } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../common/button/commonButton";
import { APP_LINK } from "../../common/menu/menuItems/menuList";
import {
  ImageContainer,
  LoginContainer,
  LoginStyle,
  PageContainer,
  StyledContainer,
} from "../../commonStyle/loginStyle";
import Logo from "../../image/logo.png";
import wardImage1 from "../../image/wardImage1.jpg";
import { authResetState, verifyOtpRequest } from "../../redux/auth/authActions";

function OtpPage() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { success, successMessage, error, errorMessage } = useSelector(
    (state) => state.auth?.registerOtp || {}
  );
  const verifyOtpState = useSelector((state) => state.auth?.registerOtp || {});
  const [timer, setTimer] = useState(60);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const onSubmit = (data) => {
    const email = localStorage.getItem("email");
    const { verification_code } = data;
    dispatch(verifyOtpRequest({ email, verification_code }));
  };
  useEffect(() => {
    if (error) {
      if (errorMessage) {
        const errorLower = errorMessage.toLowerCase();
        if (errorLower.includes("otp")) {
          setError("verification_code", {
            type: "manual",
            message: errorMessage,
          });
        }
      } else {
        setError("email", {
          type: "manual",
          message: "An error occurred. Please try again.",
        });
      }
      setTimeout(() => {
        dispatch(authResetState());
      }, 1000);
    }
  }, [error, errorMessage, setError, dispatch]);

  useEffect(() => {
    if (success) {
      setOpenSuccessDialog(true);
      const timer = setTimeout(() => {
        navigate(APP_LINK.PASSWORDRESET);
        dispatch(authResetState());
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [success, navigate, dispatch, setOpenSuccessDialog]);
  const handleResend = () => {
    setTimer(60);
    setIsResendEnabled(false);
  };
  const handleCloseDialog = () => {
    setOpenSuccessDialog(false);
    navigate(APP_LINK.OTPREQUEST);
    reset();
  };

  const handleBackToLogin = () => {
    navigate(APP_LINK.LOGIN);
    dispatch(authResetState());
  };
  return (
    <PageContainer>
      <StyledContainer>
        <ImageContainer>
          <Box sx={LoginStyle.boxOn}>
            <Box sx={LoginStyle.boxTwo}>
              <Box
                component="img"
                src={Logo}
                alt="XRay Logo"
                sx={LoginStyle.boxThree}
              />
              <Typography
                variant="h5"
                component="h1"
                sx={LoginStyle.typographyBold}
              >
                Government Hospital
              </Typography>
            </Box>
            {!isMobile && (
              <Box sx={LoginStyle.boxFore}>
                <Box
                  component="img"
                  src={wardImage1}
                  alt="Hospital facility"
                  sx={LoginStyle.boxFive}
                />
                <Typography variant="h3" sx={LoginStyle.typographyOne}>
                  " Pay Ward "
                </Typography>
              </Box>
            )}
          </Box>
        </ImageContainer>
        <LoginContainer elevation={0}>
          <Box sx={LoginStyle.boxSix}>
            <Typography
              variant={isMobile ? "h5" : "h4"}
              component="h1"
              sx={LoginStyle.typographyTwo}
            >
              Enter OTP
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={LoginStyle.textSecondary}
            >
              Enter the OTP sent to your email address.
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={LoginStyle.formField}>
                <TextField
                  fullWidth
                  label="OTP"
                  placeholder="Enter Otp...."
                  variant="outlined"
                  {...register("verification_code", {
                    required: "Otp is required",
                  })}
                  InputProps={{ sx: LoginStyle.inputField }}
                  size="small"
                  error={!!errors.verification_code}
                  helperText={errors.verification_code?.message}
                />
              </Box>
              <Box sx={LoginStyle.rememberMeContainer}>
                <CustomButton
                  type="submit"
                  text="Submit"
                  variant="contained"
                  disableElevation
                  size="small"
                  disabled={verifyOtpState?.inProgress}
                  loading={verifyOtpState?.inProgress}
                />
              </Box>
            </form>
            <Box sx={LoginStyle.footerContainer}>
              <Typography variant="body2" color="textSecondary">
                {isResendEnabled ? (
                  <Button onClick={handleResend} variant="text" color="primary">
                    Resend OTP
                  </Button>
                ) : (
                  <Typography variant="body2" color="red">
                    Resend OTP in {timer} seconds
                  </Typography>
                )}
              </Typography>
         <Link
  to="/"
  sx={{ color: "#15abc0", textDecoration: "none" }}
  underline="hover"
>
  Back to login ?
</Link>
            </Box>
          </Box>
        </LoginContainer>
      </StyledContainer>
      <Dialog
        open={openSuccessDialog}
        onClose={handleCloseDialog}
        aria-labelledby="login-success-dialog"
        PaperProps={{
          sx: {
            borderRadius: "8px",
            maxWidth: "500px",
            padding: "16px",
            textAlign: "center",
          },
        }}
      >
        <DialogContent sx={{ textAlign: "center", py: 2, width: "300px" }}>
          <CheckCircleIcon
            sx={{
              color: "#4CAF50",
              fontSize: 64,
              mb: 2,
            }}
          />
          <Typography variant="h3" sx={{ fontWeight: "bold" }}>
            OTP Verification Successful!
          </Typography>
        </DialogContent>
      </Dialog>
    </PageContainer>
  );
}

export default OtpPage;
